import React from 'react';
export function Divider() {
  return <div className="flex justify-center items-center py-12 opacity-60" data-id="element-175">
      <div className="h-px w-24 bg-brand-gold" data-id="element-176"></div>
      <div className="mx-4 text-brand-gold text-2xl" data-id="element-177">✧</div>
      <div className="h-px w-24 bg-brand-gold" data-id="element-178"></div>
    </div>;
}